'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  noResults: 'No results'
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/widgets/refinement-list/defaultTemplates.searchForFacetValue.js